import {useRpcSender} from "../RpcSender";
import {useState} from "react";
import {RpcState} from "../RpcState";
import {
  IKensuCalendarEventProto,
  IMutateCalendarEventRequest,
  MutateCalendarEventRequest,
  MutateCalendarEventResponse,
  space
} from "../../provider_api";
import IErrorProto = space.kenko.proto.IErrorProto;
import {useProviderProfile} from "../../ProviderProfileProvider";

type SendProps = {
  method: string,
  request: IMutateCalendarEventRequest,
  
  // Optional callbacks; otherwise you can just read the rpcState.
  onSuccess?: (instances: IKensuCalendarEventProto[]) => void,
  onError?: (message: string) => void
}

/**
 * This is a generic hook for ANY of the calendar RPCs -- creating, updating, or deleting
 * appointments, availability blocks, or classes. So there are up to 9. But we don't
 * create appointments through the provider calendar so it's actaully just 8.
 */
export const useMutateCalendarEvent = () => {

  const rpcSender = useRpcSender();
  const {setBusiness} = useProviderProfile();
  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'})
  const [errors, setErrors] = useState<IErrorProto[]>([]);
  const [instances, setInstances] = useState<IKensuCalendarEventProto[]>();


  const send = (props: SendProps) => {
    setInstances(undefined);
    setRpcState({state: 'pending'});

    rpcSender.send(props.method,
        MutateCalendarEventRequest.encode(props.request).finish())
        .then(value => {
          const response = MutateCalendarEventResponse.decode(value);

          if (response.okay) {
            setRpcState({state: 'success'})
            props.onSuccess && props.onSuccess(response.instances);
            
            // This happens during the onboarding, it marks the "add calendar events"
            // step as complete. This is easier than querying for calendar events since
            // the client always has a copy of the business
            if (response.optionalUpdatedBusiness) {
              setBusiness(response.optionalUpdatedBusiness);
            }
            return;
          }

          if (response.exception) {
            let message = response.exception.message || 'Unknown error, event may not have been created.';
            setRpcState({state: 'error', message: message});
            setErrors(response.exception.fieldErrors ?? []);
            props.onError && props.onError(message)
            return;
          }
        })
        .catch(e => {
          console.log('Error', e);
          props.onError && props.onError(e)
          setRpcState({state: 'error', message: 'Network error, please try again later'})
        })
  }

  return {rpcState, instances, errors, setErrors, send};
};